import { _get, getHeadersFromToken } from 'frontcore/utils/communications/apiClient'
import {
  ProfileAPIClient,
  UserProfile,
} from 'frontcore/domain/profile/model/Profile.d'

export default class ProfileAPIClientHTTP implements ProfileAPIClient {

  async request (token: string): Promise<UserProfile> {
    return await _get('profile/', { headers: getHeadersFromToken(token) }) as UserProfile
  }

}
